import React from "react";
import { useRouteError } from "react-router-dom";

import { Button } from "@/components/ui/button";

/** errorElement маршрута: ловит любую ошибку рендера страницы и показывает
 * восстановимое сообщение вместо белого экрана с сырым стеком. */
export function RouteError(): React.ReactElement {
  const error = useRouteError() as { message?: string } | undefined;
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <h1 className="text-lg font-semibold">Что-то пошло не так</h1>
      <p className="max-w-md text-sm text-muted-foreground">
        Страница столкнулась с ошибкой. Обновите страницу; если повторяется — напишите нам,
        что вы делали.
      </p>
      {error?.message && (
        <pre className="max-w-md overflow-auto rounded bg-muted p-2 text-left text-xs text-muted-foreground">
          {error.message}
        </pre>
      )}
      <Button onClick={() => window.location.reload()}>Обновить страницу</Button>
    </div>
  );
}
